"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicProvider = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const styles_2 = require("@material-ui/styles");
require("@opendoor/silica/dist/mosaic.css");
const materialThemeConfig_1 = __importDefault(require("../../config/materialThemeConfig"));
const materialThemeConfigV2_1 = __importDefault(require("../../config/materialThemeConfigV2"));
const themeV1 = styles_1.createMuiTheme(materialThemeConfig_1.default);
const themeV2 = styles_1.createMuiTheme(materialThemeConfigV2_1.default);
/**
 * MosaicProvider is a [React Context](https://reactjs.org/docs/context.html) provider that makes
 * Mosaic's Design System theming available and applied by default to all Material-UI backed
 * components below this in the component tree.
 *
 * It should preferably be at the root of your component tree.
 *
 * ---
 *
 * MosaicProvider optionally takes a `generateClassName` prop that is passed to `<StylesProvider>` inside.
 *
 * This is generally not needed unless you have multiple instances of MosaicProvider for some reason.
 *
 * See [Material's documentation](https://material-ui.com/styles/api/) for more details on this prop.
 */
const MosaicProvider = ({ children, generateClassName, themeVariant = 'v1', }) => (react_1.default.createElement(styles_2.StylesProvider, { generateClassName: generateClassName, injectFirst: true },
    react_1.default.createElement(styles_1.ThemeProvider, { theme: themeVariant === 'v2' ? themeV2 : themeV1 }, children)));
exports.MosaicProvider = MosaicProvider;
exports.default = exports.MosaicProvider;
